<template>
	<div class="introduce">
		<p>
			Common Serum Protein Database is a database containing more than 1000  medium- to high-abundance proteins that are ubiquitous in various serum samples. 
		</p>
		<p>
			The proteins were obtained from data-dependent acquisition (DDA)-based proteomics data of serum samples acquired in our lab and the literature reported  medium- to high-abundance plasma proteins.
		</p>
		<p>
			The Common Serum Protein Database partially overlaps with the Cancer Serum Atlas（cancer-secreted proteins predicted or detected in serum）. The MS/MS spectra, targeted proteomic (4D-PRM) spectra, as well as important parameters of the synthesized unique peptides of the in-database proteins, were all recorded for inquiry. Proteins query (Uniprot accession) was supported and researchers can also download the whole data of the database.
		</p>

		<mainPic />
	</div>
</template>

<script>
	import mainPic from '../components/MainPic.vue'
	
	export default {
		components: {
			'mainPic': mainPic
		}
	}
</script>

<style>
</style>
